import { render, staticRenderFns } from "./BookingMenu.vue?vue&type=template&id=04805182&scoped=true&"
import script from "./BookingMenu.vue?vue&type=script&lang=js&"
export * from "./BookingMenu.vue?vue&type=script&lang=js&"
import style0 from "./BookingMenu.vue?vue&type=style&index=0&id=04805182&scoped=true&lang=css&"
import style1 from "./BookingMenu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04805182",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VSpacer,VTab,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04805182')) {
      api.createRecord('04805182', component.options)
    } else {
      api.reload('04805182', component.options)
    }
    module.hot.accept("./BookingMenu.vue?vue&type=template&id=04805182&scoped=true&", function () {
      api.rerender('04805182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Booking/BookingMenu.vue"
export default component.exports